<template>
    <div :class="['mb-4 detail-container', { sm }]">
        <div class="detail-container-title">
            <div>{{ title }}</div>
            <div>
                <slot name="actions"></slot>
            </div>
        </div>
        <div class="detail-container-body"><slot /></div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
        },
        sm: {
            type: Boolean,
        },
    },
}
</script>

<style lang="scss">
@import "@/assets/variables.scss";

.detail-container-body {
    padding: 15px;
}
.detail-container {
    border: 1px solid $lightBorderColor;
}

.detail-container-title {
    font-size: 18px;
    color: $textColor;
    padding: 15px;
    border-bottom: 1px solid $lightBorderColor;
    background-color: $lightHoverColor;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.detail-container.sm {
    .detail-container-title {
        font-size: 14px;
        padding: 10px;
    }
    .detail-container-body {
        padding: 10px;
    }
}

/* Dark theme overrides */
.dark .detail-container {
    border-color: $darkBorderColor;
}
.dark .detail-container-title {
    color: $darkTextColor;
    border-bottom-color: $darkBorderColor;
    background-color: $darkCardBg;
}
</style>
